import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken, setUrole, getUrole, removeUrole,setUserInfo,removeUserInfo,getUserInfo  } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { stat } from 'fs'
import { Message } from 'element-ui'

const state = {
  token: getToken(),
  userId: '',
  employeeId: '',
  name: getUserInfo() ? getUserInfo().name : '',
  avatar: '',
  introduction: '',
  roles: [],
  userRoles: getUrole(),
  userInfo: getUserInfo()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USEROLES: (state, userRoles) => {
    state.userRoles = userRoles
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_EMPLOYEEID: (state, employeeId) => {
    state.employeeId = employeeId
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  // user login

  login ({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ userName: username.trim(), password: password }).then(response => {
        const { data } = response
        let userBaseInfo = {
          name: data.name,
          userName: data.userName,
          userId: data.userId
        };
        
        commit('SET_TOKEN', data.token)
        commit('SET_NAME', data.name)
        // commit('SET_USEROLES', data.roles);
      // commit('SET_ROLES', data.roles)
        commit('SET_USERID', data.userId)
		    commit('SET_EMPLOYEEID', data.employeeId)
        var avatar = './static/icon.png'
        commit('SET_AVATAR', avatar)
        setToken(data.token)
        // setUrole(data.roles);
        setUserInfo(userBaseInfo);
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        console.log('getinfo:')
        console.log(response)
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }

          const { roles, name, avatar, introduction} = data
       // const roles = ['admin']
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRoles ({ commit, state }) {
    return new Promise((resolve, reject) => {
      // console.log(state.userRoles.roles)
     // const roles = state.userRoles.roles
     const roles = state.userRoles;
      if (!roles) {
        reject('Verification failed, please Login again.')
      }
      if (!roles || roles.length <= 0) {
        Message.error('当前用户未授权访问本系统！');
        reject('用户的角色不能为空!');
      }
      commit('SET_ROLES', roles)
      //  console.log('SET_ROLES:')
      resolve(roles)
    }).catch(error => {
      reject(error)
    })
  },
  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removeUrole()
        removeUserInfo()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      removeUrole()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles ({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js